import { gql } from "graphql-tag"

const login = gql`
  type Mutation {
    login(loginInput: LoginInput!): LoginResponse!
  }
`

export default login
